export function deriveSessionsFromServerRequests(rows) {
  if (!rows || rows.length === 0) return [];

  const sessionMap = new Map();

  for (const row of rows) {
    const id = row.sessionId || "__unknown__";
    const first = row.firstSeen || row.lastSeen;
    const last = row.lastSeen || row.firstSeen;
    if (!first || !last) continue;

    if (!sessionMap.has(id)) {
      sessionMap.set(id, {
        sessionId: id,
        start: first,
        end: last,
        durationMs: 0,
        requestCount: 0,
        events: [],
      });
    }
    const session = sessionMap.get(id);
    if (new Date(first) < new Date(session.start)) session.start = first;
    if (new Date(last) > new Date(session.end)) session.end = last;
    session.requestCount += row.count || 0;
    session.events.push({
      eventName: row.eventName || "(unknown)",
      count: row.count || 0,
      totalDurationMs: row.totalDurationMs || 0,
      firstSeen: first,
      lastSeen: last,
    });
  }

  const sessions = Array.from(sessionMap.values());
  for (const session of sessions) {
    session.durationMs = new Date(session.end) - new Date(session.start);
  }

  return sessions.sort((a, b) => new Date(b.start) - new Date(a.start));
}
